import { authorizeToken } from './actions'
import { addError } from './../errors/actions'

export default ({ dispatch }) => next => action => {

  if (action.type === 'AUTHORIZE_CODE'){

    fetch('https://jpvtk3u6dl.execute-api.us-east-1.amazonaws.com/dev/login/oauth/access_token', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: action.code,
        client_id: '1cfb745895b46acc415f',
      }),
    })
    .then(response => response.json())
    .then(result => {
      if (result['error']){
        var error = new Error(result['error_description'])
        error.code = result['error']
        error.uri = result['error_uri']

        return dispatch(addError(error))
      }
      if (result['access_token']){
        return dispatch(authorizeToken(result['access_token']))
      }
      throw new Error('Unexpected response.')
    })
  }

  return next(action)
}


// WEBPACK FOOTER //
// ./src/store/token/middleware.js